import { ParcelTypeEnums } from "Data/order";
import { omitBy, isNil, find, isArray } from "lodash";

const response = (data: any, isEdit: boolean = false) => {
  // data may contain order, childrenOrders in the future
  const { childrenOrders } = data || {};

  if (isArray(childrenOrders)) {
  }

  const getTypeName = (inputType) => {
    let typeObj = find(
      data.additionalCharges ?? data.childrenOrdersData[0].additionalCharges,
      (typeObj) => {
        return typeObj.type == inputType;
      },
    );

    return typeObj?.name || "";
  };

  let newParcels: any = data?.parcels;

  // not sure how wide the impact is, for now the new model takes in isEdit
  if (isEdit) {
    // new model, get goods by order length
    const { parcels = [], dimension = {}, weight = "0", childrenOrdersData = []} = data || {};

    // for single items (< 27.08.2024), get the height, width and length from dimensions
    const oneParcel = omitBy(
      {
        goods: parcels,
        height: dimension?.height,
        width: dimension?.width,
        length: dimension?.length,
        weight,
      },
      isNil,
    );

    newParcels = [oneParcel];

    if (childrenOrdersData.length > 0) {
      newParcels = childrenOrdersData.map((childOrder: any) => {
        return {
          goods: childOrder.parcels,
          height: childOrder.dimension?.height,
          width: childOrder.dimension?.width,
          length: childOrder.dimension?.length,
          weight: childOrder.weight,
        };
      })
    }

    

    // const newParcels = parcels.map((p) => {

    //   // for multi items, to be supported soon
    //   return {
    //     goods: parcels,
    //     height: dimension?.height,
    //     width: dimension?.width,
    //     length: dimension?.length,
    //     weight: dimension?.weight,
    //   };
    // });
  }

  return omitBy(
    {
      ...data,
      isEdit: true,
      deliveryTypeName: getTypeName("DELIVERY_TYPE"),
      serviceTypeName: getTypeName("SERVICE_TYPE"),
      customer: data.senderID,
      customerLocation: data.senderLocationID,
      individualName: data.senderInfo?.fullName,
      emailAddress: data.senderInfo?.contactEmail,
      senderContact: {
        number: data.senderInfo?.contactNumber?.number,
        dialCode: data.senderInfo?.contactNumber?.countryCode,
      },
      senderAddress: {
        street1: data.senderInfo?.address?.street1,
        postcode: data.senderInfo?.address?.postcode,
        city: data.senderInfo?.address?.city,
        state: data.senderInfo?.address?.state,
        country: data.senderInfo?.address?.country,
      },
      recipientName: data.receiverInfo?.fullName,
      recipientEmail: data.receiverInfo?.contactEmail,
      recipientContact: {
        dialCode: data.receiverInfo?.contactNumber?.countryCode,
        number: data.receiverInfo?.contactNumber?.number,
      },
      recipientAddress: {
        street1: data.receiverInfo?.address?.street1,
        street2: data.receiverInfo?.address?.street2,
        postcode: data.receiverInfo?.address?.postcode,
        city: data.receiverInfo?.address?.city,
        state: data.receiverInfo?.address?.state,
        country: data.receiverInfo?.address?.country,
      },
      deliveryType: data?.deliveryType || null,
      serviceType: data?.serviceType || null,
      specialConditions: data?.specialCondition || null,
      height: data?.dimension?.height,
      width: data?.dimension?.width,
      length: data?.dimension?.length,
      parcels: newParcels,
      parcelType: data?.orderType,
    },
    isNil,
  );
};

export default response;
